import iconAtlas from '@Resources/assets/symbology/location-icon-atlas.png';
import { CompositeLayer } from '@deck.gl/core/typed';
import { IconLayer } from '@deck.gl/layers/typed';
import Supercluster from 'supercluster';
import iconMapping from './clusterIconMapping.json';

function getIconName(size) {
    if (size === 0) {
        return '';
    }
    if (size < 10) {
        return `marker-${size}`;
    }
    if (size < 100) {
        return `marker-${Math.floor(size / 10)}0`;
    }
    return 'marker-100';
}

function getIconSize(size) {
    return Math.min(100, size) / 100 + 1;
}

export default class IconClusterLayer extends CompositeLayer {
    shouldUpdateState({ changeFlags }) {
        return changeFlags.somethingChanged;
    }

    updateState({ props, oldProps, changeFlags }) {
        const rebuildIndex =
            changeFlags.dataChanged || props.sizeScale !== oldProps.sizeScale;

        if (rebuildIndex) {
            const index = new Supercluster({
                maxZoom: 16,
                radius: props.sizeScale,
            });
            index.load(
                props.data.map((d) => ({
                    geometry: { coordinates: props.getPosition(d) },
                    properties: d.properties,
                }))
            );
            this.setState({ index });
        }

        const z = Math.floor(this.context.viewport.zoom);
        if (rebuildIndex || z !== this.state.z) {
            this.setState({
                data: this.state.index.getClusters([-180, -85, 180, 85], z),
                z,
            });
        }
    }

    getPickingInfo({ info, mode }) {
        const pickedObject = info.object && info.object.properties;
        if (pickedObject) {
            if (pickedObject.cluster && mode !== 'hover') {
                info.objects = this.state.index
                    .getLeaves(pickedObject.cluster_id, 25)
                    .map((f) => f.properties);
            }
            info.object = pickedObject;
        }
        return info;
    }

    renderLayers() {
        const { data } = this.state;

        return new IconLayer(
            this.getSubLayerProps({
                id: 'icon',
                data,
                iconAtlas,
                iconMapping,
                //@ts-ignore
                sizeScale: this.props.sizeScale,
                getPosition: (d) => d.geometry.coordinates,
                getIcon: (d) =>
                    getIconName(
                        d.properties.cluster ? d.properties.point_count : 1
                    ),
                getSize: (d) =>
                    getIconSize(
                        d.properties.cluster ? d.properties.point_count : 1
                    ),
            })
        );
    }
}
